import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteAccessibleNavigation = () => {
    const [message, setMessage] = useState('');
    const location = useLocation();
    const path = location.pathname;

    useEffect(() => {
        if (path.slice(1)) {
            setTimeout(() => setMessage(`Navigated to ${path.slice(1)} page.`), 500);
        } else {
            setMessage('');
        }
    }, [path]);

    return (
        <span className='visually-hidden' role='status' aria-live='polite' aria-atomic='true'>
            {message}
        </span>
    );
};

export default RouteAccessibleNavigation;
